import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { useAuth } from '../lib/auth';

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState('');
  const [sessionId, setSessionId] = useState('');

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      // 1. Handle standard Google login callback token query param
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');
      if (token) {
        localStorage.setItem('tm_jwt', token);
        try {
          const { data } = await api.get('/auth/me');
          setUser(data.user);
          window.history.replaceState({}, '', window.location.pathname);
          nav('/dashboard', { state: { user: data.user } });
          return;
        } catch (e) {
          setError(e.response?.data?.error || 'Authentication failed');
          return;
        }
      }

      // 2. Handle Emergent mock auth callback hash param
      const hash = window.location.hash || '';
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { nav('/login'); return; }
      const sid = m[1];
      setSessionId(sid);
      try {
        const { data } = await api.post('/auth/emergent-session', { session_id: sid });
        if (data.token) {
          localStorage.setItem('tm_jwt', data.token);
        }
        setUser(data.user);
        window.history.replaceState({}, '', window.location.pathname);
        nav('/dashboard', { state: { user: data.user } });
      } catch (e) {
        if (e.response?.status === 404) {
          try {
            const fallbackRes = await api.post('/auth/emergent-session', {
              session_id: sid,
              email: 'you@gmail.com',
              full_name: 'Google User'
            });
            if (fallbackRes.data.token) {
              localStorage.setItem('tm_jwt', fallbackRes.data.token);
            }
            setUser(fallbackRes.data.user);
            window.history.replaceState({}, '', window.location.pathname);
            nav('/dashboard', { state: { user: fallbackRes.data.user } });
          } catch (err) {
            setError(err.response?.data?.error || 'Fallback login failed');
          }
        } else {
          setError(e.response?.data?.error || 'Login failed');
        }
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="tm-board-bg flex items-center justify-center min-h-screen p-4">
      <div className="tm-card p-8 max-w-md w-full text-white bg-slate-900/40 backdrop-blur-xl border border-white/10 shadow-2xl rounded-2xl text-center">
        <h2 className="text-xl font-bold mb-4">Authenticating...</h2>
        {error ? (
          <div className="text-red-400 text-sm">{error}</div>
        ) : (
          <div className="flex justify-center mt-4">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
          </div>
        )}
      </div>
    </div>
  );
}
